import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, resolveDirective as _resolveDirective, createBlock as _createBlock, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-79528272"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "flex h-[32px] items-center flex-nowrap" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "incredicon-item-height !text-[20px] !mr-0 !px-[6px]" })
], -1))
const _hoisted_2 = { class: "mr-[11px]" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "row" }, "Row height", -1))

import { IncrediButton, IncrediItem, IncrediList, IncrediMenu, IncrediTooltip } from 'incredi-ui';
import { computed, inject, ref } from 'vue';
import { AGENT_VIEWS_TYPES } from '@/views/agents/agentViews.types';
import { IKAgentsPersistentData } from '@/views/agents/agents.injectionKeys';


export default /*#__PURE__*/_defineComponent({
  __name: 'agentRowHeightButton',
  setup(__props) {

const menu = ref(false);
const showTooltip = ref(false);
const agentsPagePersistentData = inject(IKAgentsPersistentData);

const currView = computed(() => (agentsPagePersistentData?.getAgentsTableCompactView.value ? AGENT_VIEWS_TYPES.compactRow : AGENT_VIEWS_TYPES.standardRow));

const getIconClass = (view: keyof typeof AGENT_VIEWS_TYPES) => {
  if (view === AGENT_VIEWS_TYPES.compactRow) {
    return 'incredicon-item-height-compact flex';
  }
  if (view === AGENT_VIEWS_TYPES.standardRow) {
    return 'incredicon-item-height-standard flex';
  }
  return '';
};

const updateView = (view: any) => {
  agentsPagePersistentData?.setAgentsTableCompactView(view === AGENT_VIEWS_TYPES.compactRow);
  menu.value = false;
};

return (_ctx: any,_cache: any) => {
  const _directive_close_popup = _resolveDirective("close-popup")!

  return (_openBlock(), _createBlock(_unref(IncrediTooltip), {
    modelValue: showTooltip.value,
    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((showTooltip).value = $event)),
    hover: "",
    direction: "top-sticky-right",
    "offset-x": 6,
    "offset-y": 4,
    delay: 200
  }, {
    content: _withCtx(() => [
      _hoisted_3
    ]),
    default: _withCtx(() => [
      _createVNode(_unref(IncrediMenu), {
        modelValue: menu.value,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((menu).value = $event)),
        direction: 'bottom-sticky-right',
        "offset-y": 4,
        "offset-x": 5,
        "fill-width": ""
      }, {
        content: _withCtx(() => [
          _createVNode(_unref(IncrediList), null, {
            default: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(AGENT_VIEWS_TYPES), (view, index) => {
                return _withDirectives((_openBlock(), _createBlock(_unref(IncrediItem), {
                  key: index,
                  dense: "",
                  clickable: "",
                  selected: _unref(currView) === view,
                  class: _normalizeClass(["users-table-quick-filter-item !px-[4px] text-Text/text_high", { 'users-table-quick-filter-item-selected ibf-gordita-12-m': _unref(currView) === view }]),
                  "icon-class": getIconClass(view as any),
                  onClick: ($event: any) => (updateView(view as any))
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_2, _toDisplayString(view), 1)
                  ]),
                  _: 2
                }, 1032, ["selected", "icon-class", "class", "onClick"])), [
                  [_directive_close_popup]
                ])
              }), 128))
            ]),
            _: 1
          })
        ]),
        default: _withCtx(() => [
          _createVNode(_unref(IncrediButton), {
            selected: menu.value,
            design: "master",
            class: "flex !px-[0px]",
            size: "small"
          }, {
            default: _withCtx(() => [
              _hoisted_1
            ]),
            _: 1
          }, 8, ["selected"])
        ]),
        _: 1
      }, 8, ["modelValue"])
    ]),
    _: 1
  }, 8, ["modelValue"]))
}
}

})